const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

export async function getInstitutions() {
  // Fallback: intenta /select/ y si da 404, usa el endpoint tradicional
  let res = await fetch(`${API_BASE}/catalogos/instituciones/select/`);
  if (res.status === 404) {
    res = await fetch(`${API_BASE}/catalogos/instituciones/`);
  }
  if (!res.ok) return [];
  const data = await res.json();
  // Mapear solo los campos mínimos
  if (Array.isArray(data) && data.length > 0) {
    // Detectar formato tradicional
    return data.map(inst => ({
      id: inst.id_institucion || inst.id,
      name: inst.nombre_institucion || inst.name,
      clave: inst.clave_institucion || inst.clave
    }));
  }
  return [{ id: 1, name: 'Universidad Lux', clave: 'LUX' }];
}

export async function getSections(institutionId) {
  // Fallback: intenta /select/ y si da 404, usa el endpoint tradicional
  let url = institutionId
    ? `${API_BASE}/catalogos/secciones-academicas/select/?id_institucion=${institutionId}`
    : `${API_BASE}/catalogos/secciones-academicas/select/`;
  let res = await fetch(url);
  if (res.status === 404) {
    url = institutionId
      ? `${API_BASE}/catalogos/secciones-academicas/?id_institucion=${institutionId}`
      : `${API_BASE}/catalogos/secciones-academicas/`;
    res = await fetch(url);
  }
  if (!res.ok) return [];
  const data = await res.json();
  // Mapear solo los campos mínimos
  return Array.isArray(data)
    ? data.map(sec => ({ id: sec.id_seccion || sec.id, name: sec.nombre_seccion || sec.name }))
    : [];
}

export async function getPeriodTypes(institutionId) {
  // Fallback: intenta /select/ y si da 404, usa el endpoint tradicional
  let url = institutionId
    ? `${API_BASE}/catalogos/tipos-periodo-academico/select/?id_institucion=${institutionId}`
    : `${API_BASE}/catalogos/tipos-periodo-academico/select/`;
  let res = await fetch(url);
  if (res.status === 404) {
    url = institutionId
      ? `${API_BASE}/catalogos/tipos-periodo-academico/?id_institucion=${institutionId}`
      : `${API_BASE}/catalogos/tipos-periodo-academico/`;
    res = await fetch(url);
  }
  if (!res.ok) return [];
  const data = await res.json();
  // Mapear solo los campos mínimos
  return Array.isArray(data)
    ? data.map(tp => ({ id: tp.id_tipo_periodo || tp.id, name: tp.nombre_periodo || tp.name }))
    : [];
}

export async function getCycles(institutionId) {
  const url = institutionId ? `${API_BASE}/catalogos/ciclos-escolares/?id_institucion=${institutionId}` : `${API_BASE}/catalogos/ciclos-escolares/`;
  const res = await fetch(url);
  if (!res.ok) return [];
  const data = await res.json();
  console.log('[catalogs.js] Ciclos escolares crudos del backend:', data);
  // El backend CatCicloEscolarSerializer devuelve: id, nombre (NOT id_ciclo_escolar, nombre_ciclo)
  // Soportar ambos formatos para compatibilidad
  return Array.isArray(data)
    ? data.map(c => ({ 
        id: c.id || c.id_ciclo_escolar,  // Backend devuelve 'id' (source='id_ciclo_escolar')
        name: c.nombre || c.nombre_ciclo  // Backend devuelve 'nombre' (source='nombre_ciclo')
      }))
    : [];
}

export async function getCampusOptions(institutionId) {
  // Fallback: intenta /select/ filtrado por institución y si da 404 o
  // no devuelve datos, prueba sin filtro y luego el endpoint tradicional.
  const buildUrl = (useSelect, instId) => {
    if (useSelect) {
      return instId
        ? `${API_BASE}/catalogos/campus/select/?id_institucion=${instId}`
        : `${API_BASE}/catalogos/campus/select/`;
    }
    return instId
      ? `${API_BASE}/catalogos/campus/?id_institucion=${instId}`
      : `${API_BASE}/catalogos/campus/`;
  };

  const tryFetch = async (useSelect, instId) => {
    const url = buildUrl(useSelect, instId);
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      const data = await res.json();
      if (!Array.isArray(data) || data.length === 0) return null;
      return data;
    } catch {
      return null;
    }
  };

  // 1) select + institución
  let data = await tryFetch(true, institutionId);
  // 2) select sin institución
  if (!data) data = await tryFetch(true, null);
  // 3) endpoint tradicional con institución
  if (!data) data = await tryFetch(false, institutionId);
  // 4) endpoint tradicional sin institución
  if (!data) data = await tryFetch(false, null);

  if (!data) return [];

  // Mapear solo los campos mínimos
  return data.map(c => ({
    id: c.id_campus || c.id,
    name: c.nombre_campus || c.name,
    code: c.codigo_campus || c.code,
  }));
}
